export default __webpack_public_path__ + "static/media/qa.bda06bab.jpg";